import client from "../client";

export function getResponsibilityType(iri: string) {
  return client.get(iri);
}

export function getResponsibilityTypes(page?: number) {
  return client.get(`/api/v2/responsibility_types${page ? `?page=${page}` : ""}`);
}
